import React from "react";

import { IoIosArrowBack } from "react-icons/io";
import { useGetPageByIdQuery } from "../../Data/services/pageApi";
import ChangePassword from "./ChangePassword";
import ContactUs from "./ContactUs";
import { ROUTES } from "./contants";
import EditProfile from "./EditProfile";
import PrivacyPolicy from "./PrivacyPolicy";
import styles from "./styles/Details.module.scss";
import TermsAndConditions from "./TermsAndConditions";
import { useGetMyProfileQuery } from "../../Data/services/profileApi";

export default function Details({ isMobile = false, route = "", setRoute }) {
  const [data, setData] = React.useState("");
  const {
    data: ProfileData,
    isLoading: ProfileLoading,
    refetch: ProfileRefetch,
    isFetching,
  } = useGetMyProfileQuery();
  const {
    data: privacyData,
    isLoading: privacyLoading,
    refetch: privacyRefetch,
    isPrivacyFetching,
  } = useGetPageByIdQuery({ id: 1 });
  const {
    data: termsData,
    isLoading: termsLoading,
    refetch: termsRefetch,
    isTermsFetching,
  } = useGetPageByIdQuery({ id: 2 });

  const handleBackButtonClck = () => {
    setRoute("");
  };

  return (
    <div className={styles.Details}>
      {!isMobile ? (
        ""
      ) : (
        <span className={styles.backButton} onClick={handleBackButtonClck}>
          <IoIosArrowBack />
        </span>
      )}
      {route === ROUTES.EDIT_PROFILE ? (
        <EditProfile data={ProfileData} ProfileRefetch={ProfileRefetch} />
      ) : route === ROUTES.CHANGE_PASSWORD ? (
        <ChangePassword />
      ) : route === ROUTES.TERMS_CONDITIONS ? (
        <TermsAndConditions
          data={termsData}
          isLoading={termsLoading}
          refetch={termsRefetch}
        />
      ) : route === ROUTES.PRIVACY_POLICY ? (
        <PrivacyPolicy
          data={privacyData}
          isLoading={privacyLoading}
          refetch={privacyRefetch}
        />
      ) : (
        ""
      )}
    </div>
  );
}
